import { resumeDataSchema } from "@reactive-resume/schema";

import { RESUME_DRAFT_KEY } from "@/client/constants/storage-keys";
import { importResume } from "@/client/services/resume/import";

const isObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === "object" && value !== null;
};

/**
 * Creates a resume from `resume_draft` in localStorage for the current session.
 * Call after email/password registration or OAuth callback when auth cookies are set.
 * On failure, keeps the draft for a later retry.
 */
export const migrateResumeDraftToAccount = async (): Promise<void> => {
  if (typeof window === "undefined") return;

  const savedDraftJson = localStorage.getItem(RESUME_DRAFT_KEY);
  if (!savedDraftJson) return;

  try {
    const draft = JSON.parse(savedDraftJson) as unknown;
    if (!isObject(draft) || !("data" in draft) || !isObject(draft.data)) return;

    const validatedData = resumeDataSchema.parse(draft.data);

    const payload = {
      data: validatedData,
      title: typeof draft.title === "string" ? draft.title : undefined,
      visibility: "private",
    } as const;

    await importResume(payload);
    localStorage.removeItem(RESUME_DRAFT_KEY);
  } catch (error) {
    console.error("Failed to migrate resume draft after authentication:", error);
  }
};
